// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"b2ae4e06","101":"5053089c","113":"b5312de9","161":"605b9e4b","302":"4b1ad439","338":"57b6edcc","357":"2c1338cb","447":"f41b02b7","496":"428408ec","546":"6fc2480f","717":"e8ccf2df","859":"2fb96442","909":"f1790468","984":"ec2b3348"}[chunkId] + ".chunk.js";
};